import { getSubscriptionType } from "./getSubscriptionType.js";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getDefaultPlanPeriod } from "./getSubscriptionDefaultPeriod.js";
// Maps shape IDs to plan identifiers where they differ
const SHAPE_TO_PLAN_IDENTIFIER = {
    [CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.ID]: CRYSTALLIZE_IDS.SUBSCRIPTION_PLAN_IDENTIFIER.SERIES_SUBSCRIPTION,
    [CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID]: CRYSTALLIZE_IDS.SUBSCRIPTION_PLAN_IDENTIFIER.SUBSCRIPTION,
    [CRYSTALLIZE_IDS.SHAPE.PRODUCT.DIGITAL_SERVICE.ID]: CRYSTALLIZE_IDS.SUBSCRIPTION_PLAN_IDENTIFIER.DIGITAL_SUBSCRIPTION,
};
export const getSubscriptionVariantPlan = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    const planIdentifier = SHAPE_TO_PLAN_IDENTIFIER[subscriptionType] ?? subscriptionType;
    const subscriptionPlans = subscription.subscriptionPlans ?? [];
    const subscriptionPlan = subscriptionPlans.find((plan) => plan.identifier === planIdentifier);
    if (!subscriptionPlan) {
        const availablePlanIdentifiers = subscriptionPlans
            .map((plan) => plan.identifier)
            .join(", ");
        throw new Error(`Subscription plan not found - Sku ${subscription.sku}, shape ${subscriptionType}, expected ${planIdentifier}, available plans: ${availablePlanIdentifiers || "none"}`);
    }
    return subscriptionPlan;
};
export const getSubscriptionVariantPlanPeriods = (subscription) => {
    const subscriptionPlan = getSubscriptionVariantPlan(subscription);
    const subscriptionPlanPeriods = subscriptionPlan.periods;
    if (!subscriptionPlanPeriods || subscriptionPlanPeriods.length === 0)
        throw new Error(`No subscription plan periods for subscription plan ${subscriptionPlan.identifier}`);
    return subscriptionPlanPeriods;
};
export const getSubscriptionPlanPricing = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    const isBookClub = subscriptionType === CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID;
    const isDigitalService = subscriptionType === CRYSTALLIZE_IDS.SHAPE.PRODUCT.DIGITAL_SERVICE.ID;
    if (isBookClub || isDigitalService)
        return {};
    const initialPrice = getSubscriptionPlanPrice(subscription, "initial");
    const recurringPrice = getSubscriptionPlanPrice(subscription, "recurring");
    if (!recurringPrice)
        throw new Error(`No price variant set for subscription plan! - Sku: ${subscription.sku}`);
    return {
        initialPrice,
        recurringPrice,
        signUpPrice: initialPrice ?? recurringPrice,
    };
};
const getSubscriptionPlanPrice = (subscription, type) => {
    const defaultPlanPeriod = getDefaultPlanPeriod(subscription);
    const period = defaultPlanPeriod[type];
    const priceVariant = period?.priceVariants?.find(({ identifier }) => identifier === CRYSTALLIZE_IDS.PRICING.PRICE);
    if (priceVariant?.price || priceVariant?.price === 0)
        return {
            price: priceVariant.price,
            currency: priceVariant.currency ?? "NOK",
        };
    return null;
};
